import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const IconCardCheckboxUncheckedGroup: React.FC<SvgProps> = (props) => {
  return (
    <g fill="none" {...(props.group ?? {})}>
      <rect
        x="0.625"
        y="0.625"
        width="22.75"
        height="22.75"
        rx="2.375"
        fill="#FCFCFC"
        stroke="#D6D8D9"
        strokeWidth="1.25"
      />
    </g>
  );
};

export const IconCardCheckboxUncheckedSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconCardCheckboxUncheckedGroup {...props} />
    </svg>
  );
};
